import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class PersonalInformationService {
    getPersonalInformation = async (accessToken) => {
        try {
            const response = await axiosConfig.get("user/personal/GetInformation");
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Personal information not get"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    updatePersonalInformation = async (requestData, token) => {
        try {
            const response = await axiosConfig.post("user/personal/UpdateInformation", requestData);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Personal information not update"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    documentUpload = async (requestData, token) => {
        try {
            const response = await axiosConfig.post("document/upload", requestData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Document not upload"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    checkImageExpireOrNot = async (imageUrl) => {
        try {
            const response = await axiosConfig.head(imageUrl);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Session expired"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getQuestions = async (docId,visitId , token) => {
        try {
            const response = await axiosConfig.get("questionnaire/v2/getQuestions/"+docId+"/"+visitId);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No Questions "; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    submitQuestionnaire = async (requestData, token) => {
        try {
            const response = await axiosConfig.post("questionnaire/v2/submitQuestionnaire", requestData);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No questionnaire save "; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
}

const instance = new PersonalInformationService();

export default instance;
